import { fansupportPublic } from ".."

export const getSportTopOneHundred = async ({ sportId, countryId, tournamentId, teamId}) => {
    return fansupportPublic.get('/campaign/top-100', {params: {
        sportId,
        countryId,
        tournamentId,
        teamId,
    }})
}